// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Accounts from '../components/Frontend/Accounts/Accounts';
import { AccountListProvider } from '../context/AccountListContext';

export const accountsRoute = (
  <>
    <Route path="/clients_accounts/:clientId?/:clientName?" element={<MainLayout />}>
      <Route index element={
        <AccountListProvider>
          <Accounts />
        </AccountListProvider>
      } />
    </Route>
  </>
);
